import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
// import Testimonials from './components/Testimonials'; // Hidden temporarily - will revive when enough data is available
import Clients from './components/Clients';
import Contact from './components/Contact';
import Footer from './components/Footer';
// import VideoOverlay from './components/VideoOverlay'; // Removed overlay video

function App() {
  // const [showVideo, setShowVideo] = useState(false);

  // useEffect(() => {
  //   const hasSeenVideo = sessionStorage.getItem('hasSeenVideo');
  //   if (!hasSeenVideo) {
  //     setShowVideo(true);
  //   }
  // }, []);

  // const handleCloseVideo = () => {
  //   setShowVideo(false);
  //   sessionStorage.setItem('hasSeenVideo', 'true');
  // };

  return (
    <div className="bg-navy-900">
      {/* {showVideo && <VideoOverlay onClose={handleCloseVideo} />} */}
      <Navbar />
      <Hero />
      <Clients />
      <About />
      <Products />
      {/* <Testimonials /> */}
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
